import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useSearchParams } from 'react-router-dom';
import { getMAGAA000, postMAGAC010, putMAGAA000 } from '../../../services/Api';
import momentDate from '../../../shared/components/MomentDate';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MENUS } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas, ImageCheckFallback } from '../../../utils';
registerLocale('ko', ko);

const MAGAC010 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const [data, setData] = useState([]);
    const [display, setDisplay] = useState('N');
    const [searchCondition, setSearchCondition] = useState('Title');
    const [keyword, setKeyword] = useState('');
    const [dateRate, setDateRate] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const freshDisplay = () => {
        getMAGAA000('pagab010')
            .then(({ data }) => {
                setDisplay(data.display);
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        freshDisplay();
    }, []);

    const handleChangeDisplay = async (e) => {
        // const newDisplay = display === 'Y' ? 'N' : 'Y';
        try {
            await putMAGAA000('pagab010');
            freshDisplay();
        } catch (error) {
            console.log(error);
        }
    };

    const getStatusInfo = (startDate, endDate) => {
        const now = new Date();

        const start = new Date(startDate);
        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999);

        if (now >= start && now <= end) {
            return {
                text: '게재중',
                className: 'btn-time-orange',
            };
        }

        if (now < start) {
            return {
                text: '게재예정',
                className: 'btn-time-green',
            };
        }

        return {
            text: '마감',
            className: 'btn-time-gray',
        };
    };
    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.getAttribute('value-date-range');
        setDateRate(valueRangeDate);
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name) => {
        setDateRate('');
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    const getListData = (currentPage = page) => {
        const startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postMAGAC010({
            page: currentPage,
            searchCondition,
            keyword: keyword?.trim(),
            startDate: startDateFormated,
            endDate: endDateFormated,
        })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            clickSearch();
        }
    };

    const clickReset = () => {
        setSearchParams('');
        setSearchCondition('Title');
        setKeyword('');
        setDateRate('');
        setStartDate('');
        setEndDate('');
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);

    // const getTargetSiteDisplay = (targetSite) => {
    //     switch (targetSite) {
    //         case 'ALL':
    //             return 'Web, App';
    //         case 'WEB':
    //             return 'Web (PC)';
    //         case 'MOB':
    //             return 'App (Mobile)';
    //         default:
    //             return '';
    //     }
    // };

    const getTargetDisplay = (target) => {
        switch (target) {
            case 'A':
                return '전체';
            case 'C':
                return '치과';
            case 'P':
                return '개인';
            default:
                return '';
        }
    };

    // const getAppGbnTargetDisplay = (appGbnTarget) => {
    //     const displayMap = {
    //         A: '전체',
    //         110: '치과의사',
    //         201: '치과기공사 (소장)',
    //         202: '치과기공사 (기사)',
    //         310: '치과위생사 및 진료스탭',
    //         401: '학생 (치의학과)',
    //         402: '학생 (치위생과)',
    //         403: '학생 (치기공과)',
    //         999: '기타',
    //     };

    //     if (typeof appGbnTarget === 'string') {
    //         return appGbnTarget
    //             .split(',')
    //             .map((code) => displayMap[code] || '')
    //             .join(', ');
    //     }

    //     return displayMap[appGbnTarget] || '';
    // };

    const getEventGbn = (eventGbn) => {
        switch (eventGbn) {
            case 'EVT':
                return '일반형';
            case 'RVW':
                return '댓글형';
            case 'QUE':
                return '설문형';
            default:
                return '';
        }
    };

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_MENUS} />
                <div className="content-right">
                    <h1 className="title">이벤트</h1>
                    <div id="search-box">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th>제목</th>
                                    <td>
                                        <div className="select-box">
                                            {/* <select onChange={getSearchCondition} value={searchCondition}>
                                                <option value="Title">제목</option>
                                            </select> */}
                                            <input
                                                type="text"
                                                placeholder="검색어 입력"
                                                onChange={inputChange}
                                                value={keyword}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>등록일</th>
                                    <td colSpan={3}>
                                        <div className="flex group-item">
                                            <div className="group-datepicker">
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={startDateRef}
                                                        onChange={(date) => handleDateChange(date, 'startDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={startDate}
                                                        maxDate={endDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => startDateRef.current.setFocus()}
                                                    />
                                                </div>
                                                <span>~</span>
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={endDateRef}
                                                        onChange={(date) => handleDateChange(date, 'endDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={endDate}
                                                        minDate={startDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="end-date-icon"
                                                        onClick={() => endDateRef.current.setFocus()}
                                                    />
                                                </div>
                                            </div>
                                            <ul className="select-value">
                                                <li
                                                    value-date-range="today"
                                                    className={dateRate === 'today' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    오늘
                                                </li>
                                                <li
                                                    value-date-range="1week"
                                                    className={dateRate === '1week' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    일주일
                                                </li>
                                                <li
                                                    value-date-range="15days"
                                                    className={dateRate === '15days' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    15일
                                                </li>
                                                <li
                                                    value-date-range="1month"
                                                    className={dateRate === '1month' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    1개월
                                                </li>
                                                <li
                                                    value-date-range="3months"
                                                    className={dateRate === '3months' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    3개월
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>메뉴 표시</th>
                                    <td>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={handleChangeDisplay}
                                                checked={display === 'Y'}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="group-button center">
                            <button className="btn btn-gray-bold" onClick={clickSearch}>
                                검색
                            </button>
                            <button className="btn btn-gray-thin" onClick={clickReset}>
                                초기화
                            </button>
                        </div>
                    </div>

                    <div className="button-item">
                        <Link to={'/magac020'}>이벤트 등록</Link>
                    </div>
                    <div className="result">
                        <div className="count-item">
                            총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                        </div>
                        <table className="table table-gray">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th style={{ width: '220px' }}>썸네일</th>
                                    <th>제목</th>
                                    <th>이벤트 타입</th>
                                    <th style={{ width: '80px' }}>대상회원</th>
                                    <th>진행기간</th>
                                    <th>진행상태</th>
                                    <th style={{ width: '80px' }}>공개여부</th>
                                    <th style={{ width: '120px' }}>신청자</th>
                                    <th style={{ width: '80px' }}>조회수</th>
                                    <th>등록일</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{(pages.page - 1) * pages.size + (index + 1)}</td>

                                                <td>
                                                    {item?.webImg && item?.webImg !== '' && (
                                                        <p
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '10px',
                                                                marginBottom: '10px',
                                                            }}
                                                        >
                                                            {
                                                                <ImageCheckFallback
                                                                    folderName={'event'}
                                                                    imgName={item?.webImg}
                                                                    classImg={'MAGAC010_img'}
                                                                />
                                                            }
                                                        </p>
                                                    )}
                                                    {/* {item?.appImg && item?.appImg !== '' && (
                                                        <p
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '10px',
                                                            }}
                                                        >
                                                            App{' '}
                                                            {
                                                                <ImageCheckFallback
                                                                    folderName={'event'}
                                                                    imgName={item?.appImg}
                                                                    classImg={'MAGAC010_img'}
                                                                />
                                                            }
                                                        </p>
                                                    )} */}
                                                </td>
                                                <td>
                                                    <Link to={`/magac020-${item.seq}`}>{item.title}</Link>
                                                </td>
                                                <td>{getEventGbn(item?.eventGbn)}</td>
                                                <td>{getTargetDisplay(item?.target)}</td>
                                                <td>
                                                    {formatDate(item?.startDate)}
                                                    <br />
                                                    {item?.startDate && item?.endDate ? ' ~ ' : ''}
                                                    {formatDate(item?.endDate)}
                                                </td>
                                                <td>
                                                    <span
                                                        className={`btn-time ${getStatusInfo(item.startDate, item.endDate).className}`}
                                                    >
                                                        {getStatusInfo(item.startDate, item.endDate).text}
                                                    </span>
                                                </td>
                                                <td>{item?.dspYN === 'Y' ? '공개' : '비공개'}</td>
                                                <td>
                                                    {item?.isEventJoined === 'Y' && item?.eventGbn == 'RVW' && (
                                                        <Link className="btn-event-joined" to={`/magac030-${item.seq}`}>
                                                            결과보기
                                                        </Link>
                                                    )}
                                                    {item?.isEventJoined === 'Y' && item?.eventGbn == 'QUE' && (
                                                        <Link className="btn-event-joined" to={`/magac050-${item.seq}`}>
                                                            결과보기
                                                        </Link>
                                                    )}
                                                </td>
                                                <td>{item?.visitedCnt}</td>
                                                <td>{formatDate(item?.addDate)}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={10}>데이타가 없습니다.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MAGAC010;
